import {GridBasis} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridBasis';
import {
    ColumnIndex,
    ColumnKey,
    IGridCell,
    IMutableGridModel,
    RowIndex
} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {FrameAppearance} from '@mintdata-wsp/wsp/ui/components/grid/appearance/frame/FrameAppearance';
import {ListAppearance} from '@mintdata-wsp/wsp/ui/components/grid/appearance/list/ListAppearance';
import {TextHeaderCell} from '@mintdata-wsp/wsp/ui/components/grid/cells/columnHeader/TextHeaderCell';
import {FrameCell} from '@mintdata-wsp/wsp/ui/components/grid/cells/frame/FrameCell';
import {FrameColumnHeaderCell} from '@mintdata-wsp/wsp/ui/components/grid/cells/frame/FrameColumnHeaderCell';
import {FrameRowHeaderCell} from '@mintdata-wsp/wsp/ui/components/grid/cells/frame/FrameRowHeaderCell';
import {TextCell} from '@mintdata-wsp/wsp/ui/components/grid/cells/TextCell';
import {GridModel} from '@mintdata-wsp/wsp/ui/components/grid/GridModel';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import {FrameField} from '@mintdata/mint-kit/api/values/frames/FrameField';

export class GridListColumn
{
    constructor(public readonly columnKey:ColumnKey,
                public readonly columnTitle:string,
                public readonly columnLength:GridBasis)
    {}
}

export class GridModels
{
    public static newForList(columns:GridListColumn[],
                             isColumnHeaderVisible:boolean,
                             hasHorizontalLines:boolean,
                             hasVerticalLines:boolean,):IMutableGridModel
    {
        const appearance = ListAppearance.create();
        appearance.isColumnHeaderVisible = isColumnHeaderVisible;
        appearance.isRowHeaderVisible = false;
        appearance.hasHorizontalLines = hasHorizontalLines;
        appearance.hasVerticalLines = hasVerticalLines;
        appearance.hasBorder = false;

        const gridModel = GridModel.withAppearance(appearance);

        const columnKeys = [];
        for( let column of columns )
            columnKeys.push(column.columnKey);

        const createColumnHeader = (rowIndex:RowIndex, columnIndex:ColumnIndex)=>
        {
            const col = columns[columnIndex];
            const text = col.columnTitle;
            const basis = col.columnLength;
            return TextHeaderCell.withBasis(text, basis);
        };

        const backFillCells = ()=>(new TextCell(''));

        gridModel.appendColumns(columnKeys, createColumnHeader, backFillCells);
        return gridModel;
    }

    public static newForFrame():IMutableGridModel
    {
        const appearance = FrameAppearance.create();
        appearance.hasVerticalLines = true;
        appearance.hasHorizontalLines = true;
        appearance.isRowHeaderVisible = true;
        appearance.isColumnHeaderVisible = true;
        appearance.hasBorder = true;

        const newGridModel = GridModel.withAppearance(appearance);
        newGridModel.setCornerCell(FrameRowHeaderCell.forRow(-1));

        return newGridModel;
    }

    public static forExistingFrame(frame:IFrame):IMutableGridModel
    {
        const gridModel = GridModels.newForFrame();
        const fields = frame.getFields();
        const fieldNames = fields.map((f:FrameField)=>(f.name));
        const createColumnHeader = (rowIndex:RowIndex, columnIndex:ColumnIndex)=>
        {
            const aField = fields[columnIndex];
            return FrameColumnHeaderCell.fromField(aField);
        };

        gridModel.appendColumns(fieldNames, createColumnHeader, ()=>(null));

        const records = frame.getRecords();
        for (let record of records)
        {
            const row: IGridCell[] = [];
            for( let field of fields )
            {
                const cell: IValue = record.getCell(field.name, true);
                row.push(FrameCell.fromValue(cell));
            }

            gridModel.appendDataRow(row, (rowIndex:RowIndex)=>
            {
                return FrameRowHeaderCell.forRow(rowIndex);
            });
        }

        return gridModel;
    }
}
